import type { Timezone } from '../../../config/types.js'

/**
 * List of supported timezones
 *
 * label: UTC offset and location
 * value: IANA timezone name
 *
 * @example
 * { label: '(UTC-12:00) International Date Line West', value: 'Dateline Standard Time' }
 */
export const defaultTimezones: Timezone[] = [
  { label: '(UTC-11:00) Midway Island, Samoa', value: 'Pacific/Midway' },
  { label: '(UTC-11:00) Niue', value: 'Pacific/Niue' },
  { label: '(UTC-10:00) Hawaii', value: 'Pacific/Honolulu' },
  { label: '(UTC-10:00) Cook Islands', value: 'Pacific/Rarotonga' },
  { label: '(UTC-09:00) Alaska', value: 'America/Anchorage' },
  { label: '(UTC-09:00) Gambier Islands', value: 'Pacific/Gambier' },
  { label: '(UTC-08:00) Pacific Time (US & Canada)', value: 'America/Los_Angeles' },
  { label: '(UTC-08:00) Tijuana, Baja California', value: 'America/Tijuana' },
  { label: '(UTC-07:00) Mountain Time (US & Canada)', value: 'America/Denver' },
  { label: '(UTC-07:00) Arizona (No DST)', value: 'America/Phoenix' },
  { label: '(UTC-06:00) Central Time (US & Canada)', value: 'America/Chicago' },
  { label: '(UTC-06:00) Central America', value: 'America/Guatemala' },
  { label: '(UTC-05:00) Eastern Time (US & Canada)', value: 'America/New_York' },
  { label: '(UTC-05:00) Bogota, Lima, Quito', value: 'America/Bogota' },
  { label: '(UTC-04:00) Caracas', value: 'America/Caracas' },
  { label: '(UTC-04:00) Santiago', value: 'America/Santiago' },
  { label: '(UTC-03:00) Buenos Aires', value: 'America/Buenos_Aires' },
  { label: '(UTC-03:00) Brasilia', value: 'America/Sao_Paulo' },
  { label: '(UTC-02:00) South Georgia', value: 'Atlantic/South_Georgia' },
  { label: '(UTC-01:00) Azores', value: 'Atlantic/Azores' },
  { label: '(UTC-01:00) Cape Verde', value: 'Atlantic/Cape_Verde' },
  { label: '(UTC+00:00) London (GMT)', value: 'Europe/London' },
  { label: '(UTC+01:00) Berlin, Paris', value: 'Europe/Berlin' },
  { label: '(UTC+01:00) Lagos', value: 'Africa/Lagos' },
  { label: '(UTC+02:00) Athens, Bucharest', value: 'Europe/Athens' },
  { label: '(UTC+02:00) Cairo', value: 'Africa/Cairo' },
  { label: '(UTC+03:00) Moscow, St. Petersburg', value: 'Europe/Moscow' },
  { label: '(UTC+03:00) Riyadh', value: 'Asia/Riyadh' },
  { label: '(UTC+04:00) Dubai', value: 'Asia/Dubai' },
  { label: '(UTC+04:00) Baku', value: 'Asia/Baku' },
  { label: '(UTC+05:00) Islamabad, Karachi', value: 'Asia/Karachi' },
  { label: '(UTC+05:00) Tashkent', value: 'Asia/Tashkent' },
  { label: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi', value: 'Asia/Calcutta' },
  { label: '(UTC+06:00) Dhaka', value: 'Asia/Dhaka' },
  { label: '(UTC+06:00) Almaty', value: 'Asia/Almaty' },
  { label: '(UTC+07:00) Jakarta', value: 'Asia/Jakarta' },
  { label: '(UTC+07:00) Bangkok', value: 'Asia/Bangkok' },
  { label: '(UTC+08:00) Beijing, Shanghai', value: 'Asia/Shanghai' },
  { label: '(UTC+08:00) Singapore', value: 'Asia/Singapore' },
  { label: '(UTC+09:00) Tokyo, Osaka, Sapporo', value: 'Asia/Tokyo' },
  { label: '(UTC+09:00) Seoul', value: 'Asia/Seoul' },
  { label: '(UTC+10:00) Brisbane', value: 'Australia/Brisbane' },
  { label: '(UTC+10:00) Sydney, Melbourne', value: 'Australia/Sydney' },
  { label: '(UTC+10:00) Guam, Port Moresby', value: 'Pacific/Guam' },
  { label: '(UTC+11:00) New Caledonia', value: 'Pacific/Noumea' },
  { label: '(UTC+12:00) Auckland, Wellington', value: 'Pacific/Auckland' },
  { label: '(UTC+12:00) Fiji', value: 'Pacific/Fiji' },
]
